export class SaleBook {
    idBook: number;
    cName: string;
    cSku: string;
    nCost: number;
    nPrice: number;
    nDiscount: number;
    nSubtotal: number;
    nQuantity: number;
}